import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Restart,
  axiosClient,
  createQs,
  discordCdn,
  updateSettings,
} from "../utils/api";
import { Alert, Button } from "react-bootstrap";
import { createHand } from "../utils/utils";
import Loding from "../components/public/loding";
import Settings from "../components/server/settings";
import QFormat from "../components/server/QFormat";

export default function Server() {
  let [r1, setR1] = useState("");
  let [r2, setR2] = useState("");
  let [eM, setEM] = useState("");
  let [eS, setES] = useState(false);
  let [show, setShow] = useState(false);
  let [loading, setLoading] = useState(true);
  let { id } = useParams() as { id: string };
  let [server, setServer] = useState({
    id: "",
    name: "",
    icon: "",
    q: [],
    role1: "",
    role2: "",
    applys: [""],
  });
  const [inputValues, setInputValues] = useState<{ [key: string]: string }>({});
  let [isApplys, setIsApplys] = useState(false);

  useEffect(() => {
    console.log(id)
    axiosClient
      .get("/guilds/" + id)
      .then(({ data: { server: s, isApplys } }) => {console.log(s,isApplys)
        if (!s) return (window.location.href = "/");
        setIsApplys(isApplys as boolean);
        setServer(s);
        const values: { [key: string]: string } = {};
        s.q
          ?.filter((f: string) => f !== null || undefined || "")
          ?.forEach((item: string) => (values[item] = item));
        setInputValues(values);
        s.q = s?.q?.filter((f: string) => f !== null || undefined || "");
        setServer(s);
      })

      .finally(() => setLoading(false));
  }, [null]);

  if (loading) return <Loding />;
  else
    return (
      <div className="container mt-5">
        <Alert title={eM} show={eS} variant="danger">
          {eM}
        </Alert>
        <Settings
          show={show}
          onHide={() => setShow(false)}
          id={id}
          onRole1Change={(e) => setR1(e.target.value)}
          onRole2Change={(e) => setR2(e.target.value)}
          onSave={() => {
            updateSettings(id, r1, r2);
            setShow(false);
          }}
        />
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-12">
            <div className="card shadow">
              <img
                src={
                  server.icon
                    ? `${discordCdn}icons/${server?.id}/${server?.icon}.png`
                    : ""
                }
                className="card-img-top server-icon"
                alt={`${server?.name} icon`}
              />
              <div className="card-body">
                <h2 className="card-title">Server ID: {server?.id}</h2>
                <h3 className="card-title">Name: {server?.name}</h3>
                {server.role1 && server.role2 ? (
                  <>
                    <h4 className="fw-bold text text-dark">
                      the role accept id: {server.role1}
                    </h4>
                    <h4 className="fw-bold text text-dark">
                      the role reject id: {server.role2}
                    </h4>
                  </>
                ) : null}
                {server.applys?.length >= 1 ? (
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                      Restart(id)
                        .then(() => (window.location.href = `/server/${id}`))
                        .catch(({ response: { data } }) => {
                          setES(true);
                          setEM(data);
                        });
                    }}
                    variant="danger"
                  >
                    restart the applys
                  </Button>
                ) : null}
                <Button variant="primary" onClick={() => setShow(true)}>
                  Edit Settings
                </Button>
                <Button
                  variant="secondary"
                  onClick={() =>
                    navigator.clipboard.writeText(
                      `${window.location.origin}/server/${id}/apply`
                    )
                  }
                >
                  Copy Link
                </Button>
                {isApplys ? (
                  <Button href={"/server/" + id + "/applys"}>
                    View All Applyes
                  </Button>
                ) : (
                  <></>
                )}
                {server?.q?.length >= 1 ? (
                  <QFormat
                    id={id}
                    state={[inputValues, setInputValues]}
                    q={server.q}
                  />
                ) : (
                  <Button className="btn btn-primary" onClick={createHand}>
                    Create Qs
                  </Button>
                )}
                <form
                  id="create-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    let ee: string[] = [];
                    document
                      .querySelectorAll("#input-create-q")
                      .forEach((e: any) => ee.push(e.value));
                    console.log(createQs(id, ee));
                  }}
                  style={{ display: "none" }}
                >
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Submit"
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}
